import { BaseModel } from './BaseModel';

export class PDPA extends BaseModel {
  static get entity() {
    return 'pdpas';
  }

  static get fk() {
    return 'pdpa_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      latestVersion: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get('/consents/pdpa', { params });
      },

      fetchByUserId(userId, params = {}) {
        return this.get(`/consents/pdpa/user/${userId}`, { params });
      },

      saveByUserId(userId, body) {
        return this.put(`/consents/pdpa/user/${userId}`, body);
      }
    }
  };
}

export default PDPA;
